// The page's shared state: which webtop this is (slug, API), the webtop record as the server last answered it
// (`webtop`, replaced through setWebtop, since only this module may assign it), the selection, and the role
// (editor or viewer) that every menu item and write checks. No other module keeps webtop data of its own.
import { joinRoom } from './channel.js';
import { PAGE_SLUG_RE, slugOfPath } from '/model.js';

// slug and API change when another webtop is opened in place (client/lib/nav.js, through setSlug): read them when needed,
// never copy them into a constant. slug is '' on an address that is no webtop's (no record, nothing to ask the API).
export let slug = slugOfPath(location.pathname);
export let API = `/api/webtops/${slug}`;
export function setSlug(s) { slug = s; API = `/api/webtops/${s}`; }
// A webtop's address: the server's rule (server/lib/store.js), or that with a `_` in front for a webtop stored in this
// browser (applets/storage/src/local.js); the server never stores one, and api() (client/lib/ui.js) answers requests about it from the
// browser's own store.
export const SLUG_RE = PAGE_SLUG_RE;
export const isLocalSlug = (s) => s.startsWith('_');

export const $webtop = document.getElementById('webtop');

export let webtop = null;
// The page's happenings for whoever follows them without importing the module that causes them (the applet runtime
// hands them to applets, client/lib/applets.js): `webtop` (setWebtop) and `render` (client/lib/render.js).
export const bus = new EventTarget();
export const selected = new Set(); // ids of selected tiles
export const byId = (id) => webtop.shortcuts.find((s) => s.id === id);

// Roles on the current webtop: 'editor' can write (unlocked here, or a webtop with neither password nor owner), 'viewer' can only look (a
// linked or private webtop not unlocked here). Menu items with `roles: EDIT` show only to editors. Its security and
// deleting it are for whoever unlocked it (`webtop.unlocked`), not every editor.
export const currentRole = () => (webtop?.canEdit ? 'editor' : 'viewer');
// Where the open webtop is stored: 'remote' (the server) or the value of a client storage (applets/storage/src/local.js, CLIENT_STORAGES).
export const storageOf = (w = webtop) => w?.storage ?? 'remote';

// The webtop record changes as a whole (every write route answers it); other modules replace it through this.
// A record for another webtop is a late answer to a request sent before the page moved on (client/lib/nav.js): it is
// dropped, so a slow write can never put the previous webtop's tiles on this one.
// The live channel follows: the page joins the room of the webtop it now holds, or leaves (client/lib/channel.js).
export function setWebtop(d) {
  if (d && d.slug !== slug) return;
  webtop = d;
  joinRoom();
  bus.dispatchEvent(new CustomEvent('webtop', { detail: d }));
}
